<template>
    <div>
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <h4 class="mb-sm-0">{{this.label}} Team</h4>
                                    <div class="page-title-right">
                                        <ol class="breadcrumb m-0">
                                            <li class="breadcrumb-item"><router-link :to="{name : 'team'}">Our Team</router-link></li>
                                            <li class="breadcrumb-item active">Form</li>
                                        </ol>
                                    </div>
                                </div>

                                <div v-if="dataFetch">
                                    <p>Loading...</p>
                                </div>

                                <form v-if="!dataFetch" v-on:submit.prevent="onSubmit">
                                    <div class="row">
                                        <input type="hidden" name="id" v-model="form.id">
                                        <div class="form-group col-md-6 mt-3">
                                            <label>Position</label>
                                            <v-select
                                                placeholder="Select Position"
                                                label="name"
                                                :options="dataPosition"
                                                v-model="form.position"
                                                :class="{ 'is-invalid': submitted && $v.form.position.$error }"
                                                >                                    
                                            </v-select>

                                            <div v-if="submitted && !$v.form.position.required" class="invalid-feedback" style="display:block !important">Position is required</div>
                                        </div>

                                        <div class="form-group col-md-6 mt-3">
                                            <label>Name</label>
                                            <input type="text" class="form-control"
                                                placeholder="Enter data..." v-model="form.name" :class="{ 'is-invalid': submitted && $v.form.name.$error }">
                                            <div v-if="submitted && !$v.form.name.required" class="invalid-feedback">Name is required</div>    
                                        </div>

                                        <div class="form-group col-md-6 mt-3 d-none">
                                            <label for="exampleFormControlSelect1">Status</label>
                                            <select class="form-select" id="exampleFormControlSelect1" v-model="form.status">
                                                <option value="publish">Publish</option>
                                                <option value="draft">Draft</option>
                                            </select>
                                        </div>

                                        <div class="form-group col-md-6 mt-3">
                                            <label>Picture</label>
                                            <input type="file" class="form-control" name="picture" id="picture" @change="previewFiles" accept="image/png, image/gif, image/jpeg">
                                        </div>

                                        <div class="form-group col-md-6 mt-3" v-if="preview_image">
                                            <label>Preview Picture</label>
                                            <div class="thumbnail mb-4">
                                                <div class="thumb">
                                                    <a :href="preview_image" data-lightbox="1" target="blank">
                                                        <img :src="preview_image" alt="" class="img-fluid img-thumbnail" style="width:50%">
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="button-items mt-3">
                                        <button type="submit" class="btn btn-primary" :disabled="waiting">
                                        <i class="fa fa-save"></i> {{ waiting ? 'Please wait...' : 'Save' }}</button>
                                        <router-link :to="{name : 'team'}" class="btn btn-outline-primary">Back</router-link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        required
    } from "vuelidate/lib/validators";
    import vSelect from "vue-select";
    import "vue-select/dist/vue-select.css";
    
    export default {
        name: 'team',
        metaInfo: {
            title: 'Form Our Team',
            titleTemplate: '%s - Tata Hijau Asri'
        },
        components : {
            'v-select' : vSelect
        },
        created() {
            this.getPosition();
            this.getDataByID(this.$route.params.id);
        },
        data() {
            return {
                label           : 'Add',
                form : {
                    id           : "",
                    position     : [],
                    name         : "",
                    status       : "publish",
                    picture             : "",
                    previous_picture    : ""                   
                },
                dataPosition    : [],
                preview_image   : '',
                dataFetch       : false,
                submitted       : false,
                waiting         : false
            }
        },
        validations: {
            form: {
                name: {
                    required
                },
                position: {
                    required
                }
            }
        },
        methods: {
            onSubmit: function () {
                this.waiting    = true;
                this.submitted  = true;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Please complete the form',
                    });

                    this.waiting = false;
                    return;
                } else {    
                    let formData = new FormData();

                    formData.append('id', this.form.id);
                    formData.append('position_id', this.form.position.id);
                    formData.append('name', this.form.name);
                    formData.append('status', this.form.status);
                    formData.append('picture', this.form.picture);

                    this.$http.post(process.env.VUE_APP_APIHOST + 'admin/team/save', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                            if (response.data.status) {
                                this.$swal({
                                    icon: 'success',
                                    title: 'Success',
                                    text: response.data.message,
                                    confirmButtonText: 'OK'
                                }).then((result) => {
                                    if (result.value) {
                                        this.$router.push({ name: 'team' });
                                    }
                                });
                            } else {
                                this.$swal({
                                    icon: 'warning',
                                    title: 'Ups!',
                                    text: response.data.message,
                                });
                            }
                            this.waiting = false;
                        })
                    .catch(function () {
                        this.$swal({
                            icon: 'warning',
                            title: 'Ups!',
                            text: 'Please check your internet connection.',
                        });
                        this.waiting = false;
                        return;
                    });

                }
            },
            getDataByID: function(id) {
                if (typeof (id) !== 'undefined' && id !== null) {
                    this.label  = "Edit";

                    let uri     = process.env.VUE_APP_APIHOST+'admin/team/detail';

                    this.dataFetch  = true;                
                    this.$http.get(uri,{
                        params : {
                            id : id
                        }
                    }).then(res => {
                        if(res.data.status) {
                            let getResponse = res.data.data;

                            this.form.id            = getResponse.id;
                            this.form.name          = getResponse.name;
                            this.form.number_plate  = getResponse.number_plate;
                            this.form.status        = getResponse.status;
                            this.form.price         = getResponse.price;
                            this.form.position      = getResponse.position[0];
                            this.form.picture       = getResponse.picture;
                            this.preview_image      = getResponse.picture;
                            this.dataFetch          = false;
                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: 'Ups!',
                                text: res.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.$router.push({ name: 'team' });
                                }
                            });
                        }
                    });
                }
            },
            getPosition: function() {
                let uri = process.env.VUE_APP_APIHOST+'admin/team/position';
                this.$http.get(uri).then(res => {
                    this.dataPosition  = res.data.data;
                });
            },
            previewFiles(e) {
                const file = e.target.files[0];                
                var fsize = ((file.size/1024)/1024).toFixed(4); // MB
                
                if(fsize >= 2) {
                    alert("Uploaded files cannot be more than 2 MB");
                } else {
                    this.preview_image = URL.createObjectURL(file);
                    this.form.picture = file;
                }
            }
        }
    }
</script>